define.alias("ember-math-helpers/helpers/sqrt", "preview-grid/helpers/sqrt");